import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteUser = ({children}) => {
    const rol = localStorage.getItem('rol');
    if (rol === 'USUARIO') {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }
    
}

export default PrivateRouteUser;
